<template>
  <div>
    <br/>
      <div slot="header">
          <h3>
            Sensor list
          </h3>
        </div>
        <br/>
        <!-- <div slot="media">
          <img src="../../../assets/images/NewLocation/listSen.png" alt="">
        </div> -->




        <!-- Section table -->
        <vs-table :data="users">
     
      <template slot="thead">
         <vs-th>
          No
        </vs-th>
        <vs-th>
          Name
        </vs-th>
        <vs-th>
          Sensor Data
        </vs-th>
        
      
       
      </template>

      <template slot-scope="{data}">
        <vs-tr :state="indextr == 2 || indextr == 5?'success':indextr == 6?'danger':null" :key="indextr" v-for="(tr, indextr) in data" >
           <vs-td :data="data[indextr].id">
            {{data[indextr].id}}
          </vs-td>
          <vs-td :data="data[indextr].email">
            {{data[indextr].email}}
          </vs-td>

          <vs-td :data="data[indextr].username">
            {{data[indextr].username}}
          </vs-td>

         

         
        </vs-tr>
      </template>
    </vs-table>
    <br/>
    <div>
    <vs-pagination :total="40" v-model="currentx"></vs-pagination>
  </div>
        <!-- Section table -->
       
  </div>
</template>

<script>
export default {
    name: 'ListSenSor',
    data() {
      return {
        currentx: 9,
        users:[
      {
        "id": 1,
      
        "username": "Bret",
        "email": "Smoke Detector",
       
      },
      {
        "id": 2,
       
        "username": "Antonette",
        "email": "H2S Sensor", 
       
      },
      {
        "id": 3,
      
        "username": "Samantha",
        "email": "NO2 Sensor",
      
      },
      {
        "id": 4,
        
        "username": "Karianne",
        "email": "CO Sensor", 
       
      },
      {
        "id": 5,
        
        "username": "Kamren",
        "email": "Asset Sensor", 
       
      },
      {
        "id": 6,
       
        "username": "Leopoldo_Corkery",
        "email": "RS485 Adapter", 
       
      },
      {
        "id": 7,
        
        "username": "Elwyn.Skiles",
        "email": "Ultrasonic Sensor",
      
      },
      {
        "id": 8,
        
        "username": "Maxime_Nienow",
        "email": "Smart Camera", 
       
      },
      {
        "id": 9,
       
        "username": "Delphine",
        "email": "Liquid Level Sensor",
        
      },
      {
        "id": 10,
      
        "username": "Moriah.Stanton",
        "email": "Seawater Sensor", 
      
      }
    ]
      }
    },
}
</script>

<style>

</style>